import React, { useState, createElement } from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { Hero } from './components/Hero';
import { CountdownTimer } from './components/CountdownTimer';
import { BenefitsSection } from './components/BenefitsSection';
import { AboutHost } from './components/AboutHost';
import { SocialProof } from './components/SocialProof';
import { Footer } from './components/Footer';
import { AdminPanel } from './components/AdminPanel';
import { SettingsIcon } from 'lucide-react';
export function App() {
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [showAdminPanel, setShowAdminPanel] = useState(false);
  const handleFormSuccess = () => {
    setIsFormSubmitted(true);
  };
  return <>
      <Helmet data-id="element-0">
        <title data-id="element-1">Clase gratuita - Vende productos digitales</title>
        <meta name="description" content="Aprende a crear y vender productos digitales usando IA. Clase en vivo gratuita el 25 de noviembre." data-id="element-2" />
        <script data-id="element-3">
          {`
!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '1045235449792787');
fbq('track', 'PageView');
          `}
        </script>
        <noscript data-id="element-4">
          {`<img height="1" width="1" style="display:none"
src="https://www.facebook.com/tr?id=1045235449792787&ev=PageView&noscript=1"
/>`}
        </noscript>
      </Helmet>
      <div className="bg-black min-h-screen text-white font-sans overflow-x-hidden" data-id="element-5">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-purple-900/20 via-black to-black pointer-events-none" data-id="element-6"></div>
        <button onClick={() => setShowAdminPanel(true)} className="fixed bottom-4 right-4 z-40 p-3 bg-gray-900 hover:bg-gray-800 rounded-full border border-gray-700 opacity-30 hover:opacity-100 transition-opacity" title="Panel de Administración" data-id="element-7">
          <SettingsIcon size={20} className="text-gray-400" data-id="element-8" />
        </button>
        <div className="relative z-10" data-id="element-9">
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5
        }} data-id="element-10">
            <Hero onFormSuccess={handleFormSuccess} isFormSubmitted={isFormSubmitted} data-id="element-11" />
            <CountdownTimer targetDate="2025-11-25T19:00:00-05:00" data-id="element-12" />
            <BenefitsSection data-id="element-13" />
            <AboutHost data-id="element-14" />
            <SocialProof data-id="element-15" />
            <Footer data-id="element-16" />
          </motion.div>
        </div>
        <AdminPanel isOpen={showAdminPanel} onClose={() => setShowAdminPanel(false)} data-id="element-17" />
      </div>
    </>;
}